<template>
    <div class="con-btn">
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>资产{{ioFlag == ioIn ? '领用' : '归还'}}单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content-caption dashed">
            <span>{{ioFlag == ioIn ? '领用' : '归还'}}信息</span>
        </div>
        <el-form :model="deviceAppturnVoucher" :rules="voucherInfo" ref="ruleForm" class="demo-ruleForm">
            <div class="simple-form flex col-3">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">{{ioFlag == ioIn ? '领用' : '归还'}}日期</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="theDate">
                            <el-date-picker v-model="deviceAppturnVoucher.theDate" type="date" placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">{{ioFlag == ioIn ? "领用" : "归还"}}仓库</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <template v-if="!isFixedWarehouse">
                            <el-form-item prop="warehouseId">
                                <el-select v-model="warehouseId" @change="warehouseChange">
                                    <el-option v-for="item in warehouseList" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                        <span v-else>{{deviceAppturnVoucher.warehouseName}}</span>
                    </div>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label"></div>
                <div class="form-value">
                    <div class="inline-block mr20">
                        <el-form-item>
                            <el-checkbox v-model="audtoApplyState">自动申请</el-checkbox>
                        </el-form-item>
                    </div>
                    <div class="inline-block mr20" v-if="audtoApplyState">
                        <el-form-item>
                            <el-checkbox v-model="autoAuditPass">自动审核</el-checkbox>
                        </el-form-item>
                    </div>
                    <div class="inline-block mr5">
                        <el-form-item>
                            <el-checkbox v-model="autoMaskAsIdle">自动标记闲置</el-checkbox>
                        </el-form-item>
                    </div>
                </div>
            </div>
        </el-form>
        <div class="content-caption dashed">
            <span>资产信息</span>
        </div>
        <div class="simple-row">
            <div class="left">
                <el-button type="primary" @click="showDeviceListDlg()">通用选择</el-button>
                <el-button type="primary" @click="showAdvancedDlg()" :disabled="deviceAppturnVoucher.deviceItemList.length > 0 || deviceAppturnVoucher.durableItemList.length > 0">
                    <span>快捷选择</span>
                </el-button>
                <button class="swb-btn swb-btn-small ml10" :class="{'hidden' : advancedData == null}" @click="setStaff()">
                    <span>设置{{ioFlag == ioIn ? '领用' : '归还'}}人</span>
                </button>
            </div>
        </div>
        <!-- 领用即启用 -->
        <div class="simple-form flex col-3">
            <template v-if="ioFlag == ioIn && audtoApplyState && autoAuditPass && deviceAppturnVoucher.assetType != 2">
                <div class="form-group center">
                    <div class="form-label"></div>
                    <div class="form-value">
                        <el-checkbox v-model="isStarted">领用即启用</el-checkbox>
                    </div>
                </div>
                <template v-if="isStarted && audtoApplyState && autoAuditPass">
                    <div class="form-group center">
                        <div class="form-label">
                            <label class="required">启用日期</label>
                        </div>
                        <div class="form-value width-1x">
                            <el-date-picker v-model="startDate" type="date" placeholder="选择日期"></el-date-picker>
                        </div>
                    </div>
                    <div class="form-group center">
                        <div class="form-label">
                            <label class="required">入账方式</label>
                        </div>
                        <div class="form-value  width-1x">
                            <el-select v-model="acctEnterWay" placeholder="请选择">
                                <el-option v-for="item in acctEnterWayList" :label="item.text" :value="item.value"></el-option>
                            </el-select>
                        </div>
                    </div>
                </template>
            </template>
        </div>
        <div class="sim-row" v-if="((deviceAppturnVoucher.deviceItemList != null && deviceAppturnVoucher.deviceItemList.length>0) ||(deviceAppturnVoucher.durableItemList != null && deviceAppturnVoucher.durableItemList.length > 0))">
            <div class="right">
                <button class="swb-btn swb-btn-small swb-btn-primary" @click="setStaff">设置{{ioFlag == ioIn ? '领用' : '归还'}}人</button>
            </div>
        </div>

        <el-tabs v-if="advancedData == null" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="单品式管理" name="device" v-if="showDeviceFlag && deviceAppturnVoucher.assetType != 2"></el-tab-pane>
            <el-tab-pane label="批量式管理" name="durable" v-if="showDurableFlag"></el-tab-pane>
        </el-tabs>

        <div v-if="advancedData != null">
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">{{ioFlag == ioIn ? '领用' : '归还'}}部门</label>
                    </div>
                    <div class="form-value">
                        <span>{{deviceAppturnVoucher.departName}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">{{ioFlag == ioIn ? '领用' : '归还'}}人</label>
                    </div>
                    <div class="form-value">
                        <span>{{deviceAppturnVoucher.staffName}}</span>
                    </div>
                </div>
            </div>
            <swb-asset-advanced-view :advancedData="advancedData" :clearAdvanced="clearAdvanced"></swb-asset-advanced-view>
        </div>

        <div class="table-layout" v-else>
            <div v-show="activeName == 'device'">
                <div class="simple-row">
                    <div class="right">
                        <span v-if="deviceAppturnVoucher.deviceItemList != null">已选择({{deviceAppturnVoucher.deviceItemList.length}})</span>
                    </div>
                </div>
                <div class="table-layout" style="width: 100%;overflow-x: auto">
                    <el-form :model="deviceAppturnVoucher" ref="deviceInfo">
                        <table class="custom-tbl error-prompt">
                            <thead class="head">
                            <tr class="row">
                                <th width="180" style="text-align: left;">资产描述名称</th>
                                <th width="150" style="text-align: left;">型号</th>
                                <th width="150" style="text-align: left;">规格</th>
                                <th width="150" style="text-align: left;">名称</th>
                                <th width="250">商品标识码</th>
                                <th width="250">外部系统编号</th>
                                <th width="100" style="text-align: left;">分类</th>
                                <th width="100" style="text-align: left;">分类分组</th>
                                <th width="120" style="text-align: left;">品牌</th>
                                <!--<th width="200" style="text-align: left;">型号规格</th>-->
                                <th width="150" style="text-align: left;">财务类别</th>
                                <th width="90" style="text-align: center;">入账方式</th>
                                <!--<th width="80" style="text-align: right;">单原值(元)</th>-->
                                <!--<th width="80" style="text-align: right;">单净值(元)</th>-->
                                <th width="130" class="required" v-if="ioFlag == ioIn">领用部门</th>
                                <th width="130" class="required" v-else>归还部门</th>
                                <th width="100" class="required" v-if="ioFlag == ioIn">领用人</th>
                                <th width="100" class="required" v-else>归还人</th>
                                <th width="160" style="text-align: left;">批次号</th>
                                <!--<th width="160" style="text-align: right;" v-if="ioFlag != ioIn">在用数量</th>-->
                                <th width="100" style="text-align: right;">{{ioFlag == ioIn ? "领用" : "归还" }}数量</th>
                                <th width="80">单位</th>
                                <th width="120" style="text-align: left;">备注</th>
                                <th width="150">操作</th>
                            </tr>
                            </thead>
                            <tbody class="body">
                            <tr class="row" v-for="(deviceItem, index) in deviceAppturnVoucher.deviceItemList">
                                <td style="text-align: left;">{{deviceItem.title}}</td>
                                <td>{{deviceItem.model}}</td>
                                <td>{{deviceItem.fixedSpec}}</td>
                                <td>{{deviceItem.name}}</td>
                                <td>{{deviceItem.vendorUkno}}</td>
                                <td style="text-align: left;">{{deviceItem.innerNo}}</td>
                                <td style="text-align: left;">{{deviceItem.catName}}</td>
                                <td style="text-align: left;">{{getGoodsCatDevcGroupName(deviceItem.catId)}}</td>
                                <td style="text-align: left;">{{deviceItem.brandName}}</td>
                                <!--<td style="text-align: left;">{{deviceItem.modelSpec}}</td>-->
                                <td style="text-align: left;">{{deviceItem.assetKindName}}</td>
                                <td style="text-align: center;">{{acctEnterWayMap[deviceItem.acctEnterWay]}}</td>
                                <!--<td style="text-align: right;">-->
                                <!--<el-form-item :prop="'deviceItemList.' + index + '.orgWorth'" :rules="{validator: inputOrgWorth, trigger: 'blur'}">-->
                                <!--<el-input class="input-content-right" type="text" v-model.number="deviceItem.orgWorth"></el-input>-->
                                <!--</el-form-item>-->
                                <!--</td>-->
                                <!--<td style="text-align: right;">-->
                                <!--<el-form-item :prop="'deviceItemList.' + index + '.netWorth'" :rules="{validator: inputNetWorth, trigger: 'blur'}">-->
                                <!--<el-input class="input-content-right" type="text" v-model.number="deviceItem.netWorth"></el-input>-->
                                <!--</el-form-item>-->
                                <!--</td>-->
                                <td>{{deviceItem.departName}}</td>
                                <td>{{deviceItem.staffName}}</td>
                                <td style="text-align: left;">{{deviceItem.batchNo}}</td>
                                <!--<td style="text-align: right;" v-if="ioFlag != ioIn">{{deviceItem.inUseQuantity}}</td>-->
                                <td style="text-align: right;">{{deviceItem.quantity}}</td>
                                <td>{{deviceItem.theUnit}}</td>
                                <td style="text-align: left;">
                                    <el-input class="textarea-value" type="textarea" v-model="deviceItem.memo"></el-input>
                                </td>
                                <td style="text-align: left;">
                                    <a class="swb-btn-link" @click="deleteDevice(index)">移除</a>
                                    <a class="swb-btn-link" @click="setStaffInfo(index)">设置{{ioFlag == ioIn ? '领用' : '归还'}}人</a>
                                </td>
                            </tr>
                            </tbody>
                            <tfoot class="foot">
                            <tr v-if="deviceAppturnVoucher.deviceItemList == null || deviceAppturnVoucher.deviceItemList.length == 0">
                                <td colspan="17" style="text-align: center; line-height: 40px;">
                                    <span class="font-gray3">暂无数据</span>
                                </td>
                            </tr>
                            </tfoot>
                        </table>
                    </el-form>
                </div>
            </div>
            <div v-show="activeName == 'durable'">
                <div class="simple-row">
                    <div class="right">
                        <span v-if="deviceAppturnVoucher.durableItemList != null">已选择({{deviceAppturnVoucher.durableItemList.length}})</span>
                    </div>
                </div>
                <el-form :model="deviceAppturnVoucher" ref="durableInfo">
                    <div class="table-layout" style="width: 100%;overflow-x: auto">
                        <table class="custom-tbl error-prompt">
                            <thead class="head">
                            <tr class="row">
                                <th width="180" style="text-align: left;">资产描述名称</th>
                                <th width="150" style="text-align: left;">型号</th>
                                <th width="150" style="text-align: left;">规格</th>
                                <th width="150" style="text-align: left;">名称</th>
                                <th width="100" style="text-align: left;">分类</th>
                                <th width="100" style="text-align: left;">分类分组</th>
                                <th width="150" style="text-align: left;">品牌</th>
                                <th width="150" style="text-align: left;">财务类别</th>
                                <th width="90" style="text-align: center;">入账方式</th>
                                <th width="130" class="required" v-if="ioFlag == ioIn">领用部门</th>
                                <th width="130" class="required" v-else>归还部门</th>
                                <th width="100" class="required" v-if="ioFlag == ioIn">领用人</th>
                                <th width="100" class="required" v-else>归还人</th>
                                <th width="160" style="text-align: left;">批次号</th>
                                <th width="100" style="text-align: right;" v-if="ioFlag == ioIn">可用数量</th>
                                <th width="100" style="text-align: right;" v-else>在用数量</th>
                                <th width="100" style="text-align: right;" v-if="ioFlag != ioIn">在用报损数量</th>
                                <th width="100" style="text-align: right;">{{ioFlag == ioIn ? '领用' : '归还'}}数量</th>
                                <th width="100" style="text-align: right;">{{ioFlag == ioIn ? '领用' : '归还报损'}}数量</th>
                                <th width="80">单位</th>
                                <th width="120" style="text-align: left;">备注</th>
                                <th width="150">操作</th>
                            </tr>
                            </thead>
                            <tbody class="body">
                            <tr class="row" v-for="(durableItem, index) in deviceAppturnVoucher.durableItemList">
                                <td style="text-align: left;">{{durableItem.title}}</td>
                                <td>{{durableItem.model}}</td>
                                <td>{{durableItem.fixedSpec}}</td>
                                <td>{{durableItem.name}}</td>
                                <td style="text-align: left;">{{durableItem.catName}}</td>
                                <td style="text-align: left;">{{getGoodsCatDevcGroupName(durableItem.catId)}}</td>
                                <td style="text-align: left;">{{durableItem.brandName}}</td>
                                <td style="text-align: left;">{{durableItem.assetKindName}}</td>
                                <td style="text-align: center;">{{acctEnterWayMap[durableItem.acctEnterWay]}}</td>
                                <td>{{durableItem.departName}}</td>
                                <td>{{durableItem.staffName}}</td>
                                <td style="text-align: left;">{{durableItem.batchNo}}</td>
                                <td style="text-align: right;" v-if="ioFlag == ioIn">{{durableItem.inStkAvQuantity}}</td>
                                <td style="text-align: right;" v-else>{{durableItem.inUseQuantity}}</td>
                                <td style="text-align: right;" v-if="ioFlag != ioIn">{{durableItem.inUseRuinedQuantity}}</td>
                                <td style="text-align: right;">
                                    <el-form-item :prop="'durableItemList.' + index + '.quantity'" :rules="{validator: quantityChange, trigger: 'blur'}">
                                        <el-input class="text-right" type="number" v-model="durableItem.quantity" @change="changeQuantity(durableItem)"></el-input>
                                    </el-form-item>
                                </td>
                                <td style="text-align: right;">
                                    <el-form-item :prop="'durableItemList.' + index + '.quantity2'" :rules="{validator: quantity2Change, trigger: 'blur'}">
                                        <el-input class="text-right" type="number" v-model="durableItem.quantity2" @change="changeQuantity2(durableItem)"></el-input>
                                    </el-form-item>
                                </td>
                                <td>{{durableItem.theUnit}}</td>
                                <td style="text-align: left;">
                                    <el-input class="textarea-value" type="textarea" v-model="durableItem.memo"></el-input>
                                </td>
                                <td style="text-align: left;">
                                    <a class="swb-btn-link" @click="deleteDurable(index)">移除</a>
                                    <a class="swb-btn-link" @click="setStaffInfo(index)">设置{{ioFlag == ioIn ? '领用' : '归还'}}人</a>
                                </td>
                            </tr>
                            </tbody>
                            <tfoot class="foot">
                            <tr v-if="deviceAppturnVoucher.durableItemList == null || deviceAppturnVoucher.durableItemList.length == 0">
                                <td colspan="16" style="text-align: center; line-height: 40px;">
                                    <span class="font-gray3">暂无数据</span>
                                </td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                </el-form>
            </div>
        </div>

        <div class="form-toolbar">
            <button class="swb-btn swb-btn-small swb-btn-primary mr10" @click="prevStock">返回</button>
            <button class="swb-btn swb-btn-small" @click="saveAppturnVoucher">保存</button>
        </div>
    </div>

</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import{ showAssetSelectDlg, showLowCostSelectDlg } from './selectDlg'
    import{ openComStaffMainForSelectDlg } from '../orgStruct/selectDlg'
    import { openAssetAdvancedSelectDlg } from '../asset/selectDlg';
    import { getDevcGroupNameByCatId, syncSetBreadcrumb } from '../index'

    import shopStockApi from '../../api/shopStock'
    import userApi from '../../api/user'
    import shopDeviceApi from '../../api/shopDevc'
    import assetVchrApi from '../../api/assetVchr'
    //
    import SwbShopDeviceAppturnVoucherList from './ShopDeviceAppturnVoucherList'
    Routes.add(SwbShopDeviceAppturnVoucherList);

    import SwbShopDeviceAppReturnVoucherList from './ShopDeviceAppReturnVoucherList'
    Routes.add(SwbShopDeviceAppReturnVoucherList);

    export default {
        name: 'swb-shop-device-appturn-voucher-modify',
        path: '/shop/device/appturn/voucher/modify',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        customBreadcrumb: true,
        desc: '领用/归还单 - 修改',
        data: function () {
            let validateTheDate = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('请选择日期'));
                } else {
                    callback();
                }
            };
            let validateWarehouseId = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('请选择仓库'));
                } else {
                    callback();
                }
            };
            return {
                deviceAppturnVoucher: {
                    theDate: new Date(),
                    warehouseId: null,
                    deviceItemList: [],
                    durableItemList: [],
                    assetType: 0,
                },
                ioFlag: null,
                isFixedWarehouse: false,
                ioIn: getEnumInfoWith('ioFlag', 'name', 'IoIn').value,
                activeName: 'device',
                showDeviceFlag: true,
                showDurableFlag: true,
                warehouseList: [],
                merchantId: null,
                comId: null,
                voucherId: null,
                acctEnterWayMap: {},
                //
                isStarted: true,
                startDate: new Date().format('yyyy-MM-dd'),
                acctEnterWayList: [],
                acctEnterWay: 0,    // 未知
                //
                scopeEntity: {},
                audtoApplyState: false,
                autoAuditPass: false,
                autoMaskAsIdle: true,
                warehouseId: null,
                advancedData: null,
                assetType: 0,
                //
                voucherInfo: {
                    theDate: [{validator: validateTheDate, trigger: 'blur'}],
                    warehouseId: [{validator: validateWarehouseId, trigger: 'blur'}]
                },
                parentPath: null,
            }
        },
        created: function () {
            this.acctEnterWayMap = getEnumMap("acctEnterWay", "value2text");
            this.acctEnterWayList = getEnumList("acctEnterWay");    // 购置方式
            //
            this.ioFlag = this.$route.query.ioFlag || null;
            this.voucherId = this.$route.query.voucherId || null;
            this.assetType = this.$route.query.assetType || null;
            if(!Utils.isNoB(this.assetType)) {
                this.activeName = 'durable'
            }
            let isFixedWarehouse = this.$route.query.isFixedWarehouse;   // 领用单跳转
            if(typeof isFixedWarehouse == "string") {   // 防止当前界面F5刷新出错
                if(isFixedWarehouse == 'true') {
                    isFixedWarehouse = true;
                } else {
                    isFixedWarehouse = false;
                }
            }
            this.isFixedWarehouse = isFixedWarehouse;
            this.parentPath = this.$route.query.parentPath || null;
            if(this.ioFlag == this.ioIn) {
                syncSetBreadcrumb("制作领用单", this.parentPath);
            } else {
                syncSetBreadcrumb("制作归还单", SwbShopDeviceAppReturnVoucherList.path);
            }
            //
            this.getCurrentUserInfo();
            this.getWarehouseList();
        },
        methods: {
            getGoodsCatDevcGroupName: function (catId) {
                return getDevcGroupNameByCatId(catId);
            },
            getCurrentUserInfo: function () {
                let self = this;
                let theLoad = MsgBox.loading();
                userApi.getUserInfoByContext({}, function (result, jqXhr) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let data = result.data;
                        let scopeEntity = data.scopeEntity;
                        self.merchantId = scopeEntity.id;
                        self.comId = scopeEntity.comId;
                        self.bizUnitId = scopeEntity.bizUnitId;
                        //
                        self.scopeEntity = scopeEntity;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 仓库信息
            getWarehouseList: function () {
                let self = this;
                let postData = {};
                let filterItems = {};
                filterItems.locked = false;
                postData.filterItems = filterItems;
                let theLoad = MsgBox.loading();
                shopStockApi.getShopWarehouseNotPageList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let warehouseList = result.data || [];
                        if(warehouseList.length > 0) {
                            warehouseList.forEach(function (row) {
                                if(row.defaulted == true) {
                                    self.deviceAppturnVoucher.warehouseId = row.id;
                                }
                            })
                        }
                        self.warehouseList = warehouseList;
                        //
                        self.getShopDeviceAppturnVoucherInfo();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 仓库变化事件
            warehouseChange: function (val) {
                if(val != this.deviceAppturnVoucher.warehouseId) {
                    this.deviceAppturnVoucher.deviceItemList = [];
                    this.deviceAppturnVoucher.durableItemList = [];
                }
                this.deviceAppturnVoucher.warehouseId = val;
            },
            // 单原值校验
            inputOrgWorth: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback();
                } else {
                    if(!Utils.isMoneyStr(value)) {
                        callback(new Error('请输入正确的金额'));
                    } else {
                        callback();
                    }
                }
            },
            // 单净值校验
            inputNetWorth: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback();
                } else {
                    if(!Utils.isMoneyStr(value)) {
                        callback(new Error('请输入正确的金额'));
                    } else {
                        callback();
                    }
                }
            },
            // 领用数量
            quantityChange: function (rule, value, callback) {
                let name = "";
                if(this.ioFlag == this.ioIn) {
                    name = "领用";
                } else {
                    name = "归还";
                }
                if(Utils.isNoB(value)) {
                    callback(new Error("请输入" + name + "数量"));
                } else {
                    if(!Utils.isNaturalStr(value, true)) {
                        callback(new Error("请输入大于0的整数！"));
                    } else {
                        callback();
                    }
                }
            },
            quantity2Change: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error("请输入归还报损数量"));
                } else {
                    if(value < 0) {
                        callback(new Error("不可小于0"));
                    } else {
                        callback();
                    }
                }
            },
            changeQuantity: function (durableItem) {
                if(this.ioFlag == this.ioIn) {
                    let inStkAvQuantity = durableItem.inStkAvQuantity;
                    let quantity = durableItem.quantity;
                    //
                    if(quantity > inStkAvQuantity) {
                        Toast.show(durableItem.title + "领用数量不能超过可用数量，可用数量为" + inStkAvQuantity);
                    }
                } else {
                    let inUseQuantity = durableItem.inUseQuantity;
                    let quantity = durableItem.quantity;
                    //
                    if(quantity > inUseQuantity) {
                        Toast.show(durableItem.title + "归还数量不能超过在用数量，在用数量为" + inUseQuantity);
                    }
                }
            },
            changeQuantity2: function (durableItem) {
                if(this.ioFlag == this.ioIn) {
                    let inStkAvQuantity = durableItem.inStkAvQuantity;
                    let quantity = durableItem.quantity;
                    //
                    if(quantity > inStkAvQuantity) {
                        Toast.show(durableItem.title + "领用数量不能超过可用数量，可用数量为" + inStkAvQuantity);
                    }
                } else {
                    let inUseRuinedQuantity = durableItem.inUseRuinedQuantity;
                    let quantity2 = durableItem.quantity2;
                    //
                    if(quantity2 > inUseRuinedQuantity) {
                        Toast.show(durableItem.title + "归还报损数量不能超过在用报损数量，在用报损数量为" + inUseRuinedQuantity);
                    }
                }
            },
            //
            getShopDeviceAppturnVoucherInfo: function () {
                let self = this;
                let postData = {};
                postData.id = self.voucherId;
                let theLoad = MsgBox.loading();
                assetVchrApi.getShopDeviceAppturnVoucherIndcludeItems(postData, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        let deviceAppturnVoucher = result.data;
                        //
                        let deviceItemList = [];    // deviceAppturnVoucher.deviceItemList;
                        let durableItemList = [];   // deviceAppturnVoucher.durableItemList;
                        let itemList = deviceAppturnVoucher.itemList || [];
                        if(itemList.length > 0) {
                            for(let i = 0; i < itemList.length; i++) {
                                let item = itemList[i];
                                if(item.durable) {
                                    durableItemList.push(item);
                                } else {
                                    deviceItemList.push(item);
                                }
                            }
                        }
                        deviceAppturnVoucher.deviceItemList = Utils.merge([], deviceItemList);
                        deviceAppturnVoucher.durableItemList = Utils.merge([], durableItemList);
                        //
                        deviceAppturnVoucher.assetType = deviceAppturnVoucher.assetType == null ? 0 : deviceAppturnVoucher.assetType;
                        if(deviceAppturnVoucher.assetType == 2) {
                            self.activeName = 'durable';
                        }
                        self.assetType = deviceAppturnVoucher.assetType;
                        self.deviceAppturnVoucher = Utils.merge({}, deviceAppturnVoucher);
                        self.warehouseId = deviceAppturnVoucher.warehouseId;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            // 获取设备的tab
            handleClick: function () {
            },
            // 快捷选择
            showAdvancedDlg(){
                let self = this;
                let deviceAppturnVoucher = this.deviceAppturnVoucher;
                if(deviceAppturnVoucher.durableItemList.length > 0 || deviceAppturnVoucher.deviceItemList.length > 0) {
                    MsgBox.warning("请清空资产信息后再试");
                    return;
                }
                let warehouseId = deviceAppturnVoucher.warehouseId;
                if(Utils.isNoB(warehouseId)) {
                    Toast.show("请选择仓库");
                    return;
                }
                //
                let singleFilter = {};      // 单品式条件
                let batchFilter = {};       // 批量式条件
                let showDepart = true;
                if(this.ioFlag == this.ioIn) {// 领用
                    singleFilter.inStock = true;
                    showDepart = false;
                } else {
                    singleFilter.inUse = true;
                    batchFilter.lowCostFlag = false;    // 耗材仅可领用，不可归还
                    batchFilter.assetReturn = true;     // 在用数量大于0
                }
                let advancedData = self.advancedData || {};
                let params = {
                    retailerShopId: self.bizUnitId,
                    warehouseId: warehouseId,
                    showSingleComn: true,
                    showSingleSpecial: true,
                    showBatchComn: true,
                    showBatchLow: false,
                    showDepart: showDepart,
                    showCat: true,
                    showKind: true,
                    showAcctEnterWay: true,
                    resultFilter: advancedData.resultFilter || null,
                    singleFilter: singleFilter,
                    batchFilter: batchFilter
                };
                openAssetAdvancedSelectDlg(params, function (advancedData) {
                    self.advancedData = advancedData;
                });
            },
            // 高级条件删除
            clearAdvanced: function () {
                //
                this.advancedData = null;
            },
            handleItemIdsList(itemList, durable) {
                let list = [];
                if(itemList != null && itemList.length > 0) {
                    itemList.forEach(function (item) {
                        if(item.durable == durable) {
                            list.push(item);
                        }
                    });
                }
                return list.pluck('deviceXId') || [];
            },
            // 通用选择-资产信息
            showDeviceListDlg: function () {
                let self = this;
                let warehouseId = self.deviceAppturnVoucher.warehouseId;
                if(Utils.isNoB(warehouseId)) {
                    Toast.show("请选择领用仓库");
                    return false;
                }
                let deviceItemList = self.deviceAppturnVoucher.deviceItemList || [];
                let durableItemList = self.deviceAppturnVoucher.durableItemList || [];
                let selectSingleIds = this.handleItemIdsList(deviceItemList, false);
                let selectBatchIds = this.handleItemIdsList(durableItemList, true);
                //
                let selectAll = true;
                let lowCostFlag = null;
                let selectBatch = false;
                let batchCheck = {};
                // 单品式管理-条件
                let singleFilter = {
                    warehouseId: warehouseId,
                    retailerShopId: self.bizUnitId,
                    cleared: false,
                    locked: false
                };
                if(!Utils.isNoB(self.ioFlag) && self.ioFlag == self.ioIn) { // 领用
                    singleFilter.inStock = true;
                } else { // 归还
                    singleFilter.inUse = true;
                    lowCostFlag = false;
                }
                // 批量式管理-条件
                let batchFilter = {
                    retailerShopId: self.bizUnitId,
                    warehouseId: warehouseId,
                    durable: true,
                    lowCostFlag: lowCostFlag
                };
                let params = {
                    selectAll: selectAll,
                    selectBatch: selectBatch,
                    //
                    singleFilter: singleFilter,
                    selectSingleIds: selectSingleIds,
                    //
                    batchFilter: batchFilter,
                    batchCheck: batchCheck,
                    selectBatchIds: selectBatchIds
                };
                showAssetSelectDlg(params, function (resultData) {
                    //
                    self.handleCallbackDevice(resultData);
                });
            },
            // 处理选择数据
            handleCallbackDevice(resultData) {
                let self = this;
                //
                let batchDeviceList = resultData.batchDeviceList || [];
                let singleDeviceList = resultData.singleDeviceList || [];
                //
                let itemList = [];
                if(singleDeviceList != null && singleDeviceList.length > 0) {
                    singleDeviceList.forEach(function (item) {
                        item.durable = false;
                        itemList.push(item);
                    });
                }
                if(batchDeviceList != null && batchDeviceList.length > 0) {
                    batchDeviceList.forEach(function (item) {
                        item.durable = true;
                        itemList.push(item);
                    });
                }
                //
                let deviceAppturnVoucher = this.deviceAppturnVoucher;
                let deviceItemList = deviceAppturnVoucher.deviceItemList || [];
                let durableItemList = deviceAppturnVoucher.durableItemList || [];
                itemList.forEach(function (asset) {
                    if(!Utils.isTrue(asset.durable)) {      // 单品式管理
                        let item = self.stuffDeviceToItem(asset);
                        //
                        deviceItemList.push(item);
                    } else {
                        let item = self.stuffDurableToItem(asset);
                        //
                        durableItemList.push(item);
                    }
                });
                deviceAppturnVoucher.deviceItemList = Utils.merge([], deviceItemList);
                deviceAppturnVoucher.durableItemList = Utils.merge([], durableItemList);
                this.deviceAppturnVoucher = Utils.merge({}, deviceAppturnVoucher);
            },
            // 单品式设备
            stuffDeviceToItem: function (deviceItem) {
                let item = {};
                let scopeEntity = this.scopeEntity;
                if(!Utils.isNoB(deviceItem)) {
                    item.deviceXId = deviceItem.id;
                    item.durable = false;
                    item.rented = deviceItem.rented;
                    item.tmpNo = deviceItem.tmpNo;
                    item.vendorUkno = deviceItem.vendorUkno;
                    item.innerNo = deviceItem.innerNo;
                    item.skuId = deviceItem.skuId;
                    item.catId = deviceItem.catId;
                    item.catName = deviceItem.catName;
                    item.brandId = deviceItem.brandId;
                    item.brandName = deviceItem.brandName;
                    item.title = deviceItem.title;
                    item.model = deviceItem.model;
                    item.fixedSpec = deviceItem.fixedSpec;
                    item.modelSpec = deviceItem.modelSpec;
                    item.acctEnterWay = deviceItem.acctEnterWay;
                    item.orgWorth = deviceItem.orgWorth;
                    item.netWorth = deviceItem.netWorth;
                    item.assetKindId = deviceItem.assetKindId;
                    item.assetKindName = deviceItem.assetKindName;
                    item.inStkAvQuantity = 1;
                    item.inUseQuantity = 1;
                    item.theUnit = deviceItem.theUnit;
                    item.batchNo = deviceItem.batchNo;
                    item.svcNo = deviceItem.svcNo;
                    item.quantity = 1;
                    //
                    item.departId = scopeEntity.comId;
                    item.departName = scopeEntity.comName;
                    item.staffId = scopeEntity.staffId;
                    item.staffName = scopeEntity.staffName;
                }
                // 优先设备上的责任人为领用人
                let departId = deviceItem.departId;
                let principalId = deviceItem.principalId;
                if(!Utils.isNoB(departId) && !Utils.isNoB(principalId)) {
                    item.departId = departId;
                    item.departName = deviceItem.departName;
                    //
                    item.staffId = principalId;
                    item.staffName = deviceItem.principalName;
                }
                return item;
            },
            // 批量式设备
            stuffDurableToItem: function (durableItem) {
                let item = {};
                let scopeEntity = this.scopeEntity;
                if(!Utils.isNoB(durableItem)) {
                    item.deviceXId = durableItem.id;
                    item.durable = durableItem.durable;
                    item.catName = durableItem.catName;
                    item.catId = durableItem.catId;
                    item.skuId = durableItem.skuId;
                    item.goodsId = durableItem.goodsId;
                    item.brandId = durableItem.brandId;
                    item.brandName = durableItem.brandName;
                    item.title = durableItem.title;
                    item.memo = durableItem.memo;
                    item.model = durableItem.model;
                    item.fixedSpec = durableItem.fixedSpec;
                    item.modelSpec = durableItem.modelSpec;
                    item.acctEnterWay = durableItem.acctEnterWay;
                    item.orgWorth = durableItem.orgWorth;
                    item.netWorth = durableItem.netWorth;
                    item.assetKindId = durableItem.assetKindId;
                    item.assetKindName = durableItem.assetKindName;
                    item.inStkAvQuantity = durableItem.inStkAvQuantity;
                    item.inUseQuantity = durableItem.inUseQuantity;
                    item.inUseRuinedQuantity = durableItem.inUseRuinedQuantity;
                    item.batchNo = durableItem.batchNo;
                    item.svcNo = durableItem.svcNo;
                    item.theUnit = durableItem.theUnit;
                    item.lowCostFlag = durableItem.lowCostFlag;
                    item.rented = false;
                    //
                    item.departId = scopeEntity.comId;
                    item.departName = scopeEntity.comName;
                    item.staffId = scopeEntity.staffId;
                    item.staffName = scopeEntity.staffName;
                }
                return item;
            },
            // 移除普通设备
            deleteDevice: function (index) {
                let deviceItemList = this.deviceAppturnVoucher.deviceItemList || [];
                for(let i = 0; i < deviceItemList.length; i++) {
                    if(i == index) {
                        deviceItemList.splice(i, 1);
                        break;
                    }
                }
                this.deviceAppturnVoucher.deviceItemList = Utils.merge([], deviceItemList);
            },
            // 移除耐用品
            deleteDurable: function (index) {
                let durableItemList = this.deviceAppturnVoucher.durableItemList || [];
                for(let i = 0; i < durableItemList.length; i++) {
                    if(i == index) {
                        durableItemList.splice(i, 1);
                        break;
                    }
                }
                this.deviceAppturnVoucher.durableItemList = Utils.merge([], durableItemList);
            },
            // 设置人员
            setStaff: function () {
                let self = this;
                let scopeEntity = self.scopeEntity;
                let bizUnitId = scopeEntity.bizUnitId;
                let comId = scopeEntity.comId;
                if(!Utils.isNoB(self.advancedData)) {
                    let deviceAppturnVoucher = self.deviceAppturnVoucher;
                    openComStaffMainForSelectDlg({bizUnitId: bizUnitId, defComId: comId}, function (result, theDlg) {
                        theDlg.close();
                        deviceAppturnVoucher.departId = result.srcComId;
                        deviceAppturnVoucher.departName = result.srcComName;
                        deviceAppturnVoucher.staffId = result.id;
                        deviceAppturnVoucher.staffName = result.name;
                        self.deviceAppturnVoucher = Utils.merge({}, deviceAppturnVoucher);
                    });
                } else {
                    if(self.activeName == 'device') {
                        let deviceItemList = self.deviceAppturnVoucher.deviceItemList;
                        openComStaffMainForSelectDlg({bizUnitId: bizUnitId, defComId: comId}, function (result, theDlg) {
                            theDlg.close();
                            deviceItemList.forEach(function (deviceAppturnItem) {
                                deviceAppturnItem.departId = result.srcComId;
                                deviceAppturnItem.departName = result.srcComName;
                                deviceAppturnItem.staffId = result.id;
                                deviceAppturnItem.staffName = result.name;
                            });
                            self.deviceAppturnVoucher.deviceItemList = Utils.merge([], deviceItemList);
                        });
                    } else {
                        let durableItemList = self.deviceAppturnVoucher.durableItemList;
                        openComStaffMainForSelectDlg({bizUnitId: bizUnitId, defComId: comId}, function (result, theDlg) {
                            theDlg.close();
                            durableItemList.forEach(function (durableAppturnItem) {
                                durableAppturnItem.departId = result.srcComId;
                                durableAppturnItem.departName = result.srcComName;
                                durableAppturnItem.staffId = result.id;
                                durableAppturnItem.staffName = result.name;
                            });
                            self.deviceAppturnVoucher.durableItemList = Utils.merge([], durableItemList);
                        });
                    }
                }
            },
            // 单行设置人员
            setStaffInfo: function (index) {
                let self = this;
                let scopeEntity = self.scopeEntity;
                let bizUnitId = scopeEntity.bizUnitId;
                let comId = scopeEntity.comId;
                if(self.activeName == 'device') {
                    let deviceItemList = self.deviceAppturnVoucher.deviceItemList;
                    openComStaffMainForSelectDlg({bizUnitId: bizUnitId, defComId: comId}, function (result, theDlg) {
                        theDlg.close();
                        let deviceAppturnItem = deviceItemList[index];
                        deviceAppturnItem.departId = result.srcComId;
                        deviceAppturnItem.departName = result.srcComName;
                        deviceAppturnItem.staffId = result.id;
                        deviceAppturnItem.staffName = result.name;
                        //
                        self.deviceAppturnVoucher.deviceItemList = Utils.merge([], deviceItemList);
                    });
                } else {
                    let durableItemList = self.deviceAppturnVoucher.durableItemList;
                    openComStaffMainForSelectDlg({bizUnitId: bizUnitId, defComId: comId}, function (result, theDlg) {
                        theDlg.close();
                        let durableAppturnItem = durableItemList[index];
                        durableAppturnItem.departId = result.srcComId;
                        durableAppturnItem.departName = result.srcComName;
                        durableAppturnItem.staffId = result.id;
                        durableAppturnItem.staffName = result.name;
                        //
                        self.deviceAppturnVoucher.durableItemList = Utils.merge([], durableItemList);
                    });
                }
            },
            //返回
            prevStock: function () {
                let self = this;
                self.$router.back(-1);
            },
            // 保存固定资产领用/归还单
            saveAppturnVoucher: function () {
                let self = this;
                let deviceAppturnVoucher = self.deviceAppturnVoucher;
                deviceAppturnVoucher.theDate = deviceAppturnVoucher.theDate.format('yyyy-MM-dd');
                deviceAppturnVoucher.ioFlag = self.ioFlag;
                self.warehouseList.forEach(function (warehouse) {
                    if(warehouse.id == deviceAppturnVoucher.warehouseId) {
                        deviceAppturnVoucher.warehouseName = warehouse.name;
                    }
                });
                deviceAppturnVoucher.autoApplyState = self.audtoApplyState;
                deviceAppturnVoucher.autoAuditPass = self.autoAuditPass;
                deviceAppturnVoucher.autoMaskAsIdle = Utils.isTrue(self.autoMaskAsIdle);
                if(self.ioFlag == self.ioIn) {  // 申领
                    let isStarted = self.isStarted;
                    deviceAppturnVoucher.isStarted = isStarted;
                    if(isStarted) {
                        let startDate = self.startDate || null;
                        if(Utils.isNoB(startDate)) {
                            Toast.show("请选择启用日期！");
                            return;
                        }
                        deviceAppturnVoucher.startDate = startDate.format("yyyy-MM-dd");
                        let acctEnterWay = self.acctEnterWay;
                        if(Utils.isNoB(acctEnterWay)) {
                            Toast.show("请选择入账方式！");
                            return;
                        }
                        deviceAppturnVoucher.acctEnterWay = acctEnterWay;
                    }
                }
                //
                if(this.advancedData != null) {
                    if(Utils.isNoB(deviceAppturnVoucher.departId) || Utils.isNoB(deviceAppturnVoucher.staffId)) {
                        Toast.show("请设置" + (self.ioFlag == self.ioIn ? "领用" : "归还") + "部门，" + (self.ioFlag == self.ioIn ? "领用" : "归还") + "人");
                        return;
                    }
                    deviceAppturnVoucher.isAdvanced = true;
                    deviceAppturnVoucher.filterItems = this.advancedData.resultFilter || null;
                    deviceAppturnVoucher.itemList = [];
                    //
                    self.doReqSaveAppturnVoucher(deviceAppturnVoucher);
                } else {
                    self.$refs['ruleForm'].validate(function (valid) {
                        if(valid) {
                            // 普通设备
                            let deviceItemList = deviceAppturnVoucher.deviceItemList || [];
                            // 耐用设备
                            let durableItemList = deviceAppturnVoucher.durableItemList || [];
                            //
                            if(deviceItemList.length <= 0 && durableItemList.length <= 0) {
                                Toast.show("请选择资产");
                                return;
                            }
                            // 有设备的时候，进行设备相关的校验
                            if(deviceItemList.length > 0) {
                                // 领用即启用校验
                                let validateFailure = false;
                                self.$refs['deviceInfo'].validate(function (valid) {
                                    if(valid) {
                                        //
                                        for(let i = 0; i < deviceItemList.length; i++) {
                                            let item = deviceItemList[i];
                                            if(Utils.isNoB(item.departId) || Utils.isNoB(item.staffId)) {
                                                validateFailure = true;
                                                Toast.show("请为单品式资产设置人员!");
                                                break;
                                            }
                                        }
                                    } else {
                                        validateFailure = true;
                                        Toast.show("请输入单品式资产中相应的数据！");
                                    }
                                });
                                if(validateFailure) {
                                    return;
                                }
                            }
                            // 有耐用品的时候进行耐用品相关的校验
                            if(durableItemList.length > 0) {
                                let validateFailure = false;
                                self.$refs['durableInfo'].validate(function (valid) {
                                    if(valid) {
                                        //
                                        for(let i = 0; i < durableItemList.length; i++) {
                                            let item = durableItemList[i];
                                            if(Utils.isNoB(item.departId) || Utils.isNoB(item.staffId)) {
                                                validateFailure = true;
                                                Toast.show("请为批量式资产设置人员");
                                                break;
                                            }
                                            if(Utils.isNoB(item.quantity)) {
                                                validateFailure = true;
                                                Toast.show("请设置" + (self.ioFlag == self.ioIn ? "领用" : "归还") + "数量");
                                                break;
                                            }
                                            if(self.ioFlag == self.ioIn) {
                                                let inStkAvQuantity = item.inStkAvQuantity;
                                                //
                                                if(item.quantity > inStkAvQuantity) {
                                                    validateFailure = true;
                                                    Toast.show(item.title + "领用数量不能超过可用数量，可用数量为" + inStkAvQuantity);
                                                    break;
                                                }
                                            } else {
                                                let inUseQuantity = item.inUseQuantity;
                                                let inUseRuinedQuantity = item.inUseRuinedQuantity;
                                                //
                                                if(item.quantity > inUseQuantity) {
                                                    validateFailure = true;
                                                    Toast.show(item.title + "归还数量不能超过在用数量，在用数量为" + inUseQuantity);
                                                    break;
                                                }
                                                if(item.quantity2 > inUseRuinedQuantity) {
                                                    validateFailure = true;
                                                    Toast.show(item.title + "归还报损数量不能超过在用报损数量，在用报损数量" + inUseRuinedQuantity);
                                                    break;
                                                }
                                            }
                                        }
                                    } else {
                                        validateFailure = true;
                                        Toast.show("请输入批量式资产中相应的数据！");
                                    }
                                });
                                if(validateFailure) {
                                    return;
                                }
                            }
                            //
                            let itemList = deviceItemList.concat(durableItemList);
                            deviceAppturnVoucher.itemList = itemList;
                            //
                            if(itemList.length > 500) {
                                MsgBox.warning("【资产】支持最大单据级条目为500条！现" + itemList.length + "条！");
                                return;
                            }
                            // 判断资产类型(2019-12-04 现在只把易耗品拆除)
                            if(self.ioFlag == self.ioIn && self.assetType == 2) {
                                deviceAppturnVoucher.assetType = self.assetType;
                            } else {
                                deviceAppturnVoucher.assetType = null;
                            }
                            deviceAppturnVoucher.assetTypeFlag = true;
                            self.doReqSaveAppturnVoucher(deviceAppturnVoucher);
                        }
                    });
                }

            },
            doReqSaveAppturnVoucher: function (deviceAppturnVoucher) {
                let self = this;
                let theLoad = MsgBox.loading();
                assetVchrApi.modifyShopDeviceAppturnVoucher(deviceAppturnVoucher, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        MsgBox.success("保存成功");
                        if(self.ioFlag == self.ioIn) {
                            // 跳转领用单
                            self.$router.push({
                                path: self.parentPath
                            });
                        } else {
                            // 跳转归还单
                            self.$router.push({
                                path: SwbShopDeviceAppReturnVoucherList.path
                            });
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/compo/retailer/ShopDeviceApptrurnVoucherEdit.vue